import { useRef } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import SaleEditClient from "@/components/sales/sale-edit-client";
import SaleForm from "@/components/sales/sales-form/sales-form";
import { Id } from "@/convex/_generated/dataModel";

export const Route = createFileRoute("/_authenticated/sales/$id/edit")({
  component: SaleEditPage,
});

function SaleEditPage() {
  const { id } = Route.useParams();

  // Capturamos el modo "new" SOLO al montar. Cuando el form crea el borrador y
  // sincroniza la URL al id real, este ref no cambia, así seguimos renderizando
  // el mismo SaleForm (no se remonta al edit client) → sin flash del skeleton.
  // En una recarga con id real, el ref es false y se hidrata vía el edit client.
  const startedNewRef = useRef(id === "new");

  if (startedNewRef.current) {
    return (
      <RouteGuardPermissions
        permissions={[{ module: "sales", actions: ["read", "update"] }]}
      >
        <SaleForm />
      </RouteGuardPermissions>
    );
  }

  return <SaleEditClient saleId={id as Id<"sales">} />;
}
